import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBagIcon } from 'lucide-react';
import { usePrototype } from '../../contexts/PrototypeContext';
export function BagButton() {
  const {
    quantity
  } = usePrototype();
  return <Link to="/cart" aria-label={`Bag, ${quantity} ${quantity === 1 ? 'item' : 'items'}`} className="relative inline-flex h-11 min-w-[44px] items-center justify-center gap-2 rounded-[3px] px-2 text-ink transition-colors duration-150 ease-out hover:text-bronze-deep" data-id="element-282" data-mp="zsgdv6439p1l">
      <ShoppingBagIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-283" data-mp="vs69tyzux8pd" />
      <span className="hidden text-[14px] font-medium sm:inline" data-id="element-284" data-mp="h3jjz3clsyjw">Bag</span>
      {quantity > 0 && <span aria-hidden="true" className="inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-ink px-1.5 text-[11px] font-semibold text-canvas" data-id="element-285" data-mp="m2mqytc59eui">
          {quantity}
        </span>}
    </Link>;
}